import { render, staticRenderFns } from "./PhotoIcon.vue?vue&type=template&id=a00db6a8&scoped=true"
import script from "./PhotoIcon.vue?vue&type=script&lang=js"
export * from "./PhotoIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a00db6a8",
  null
  
)

export default component.exports